import { IDate } from '@models';
import { formatDateWithOffset } from '@utils';
import { Col, DatePicker, Row, Select } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

interface IProps {
  dateTime: IDate | undefined;
  setDate: (value: IDate) => void;
}

export const DateTimeSelect: React.FC<IProps> = ({ dateTime, setDate }) => {
  const handleDateChange = async (date: dayjs.Dayjs | null) => {
    if (!date) return;
    const startH = dateTime?.startAt ? dayjs(dateTime.startAt).hour() : 8;
    const startM = dateTime?.startAt ? dayjs(dateTime.startAt).minute() : 0;
    const start = dayjs(date).set('hour', startH).set('minute', startM);
    setDate({ startAt: formatDateWithOffset(start) });
  };

  const handleTimeChange = async (value: string) => {
    const time = value.split(':');
    const start = dayjs(dateTime?.startAt).hour(Number(time[0])).minute(Number(time[1])).second(0);
    setDate({ startAt: formatDateWithOffset(start) });
  };

  return (
    <Row gutter={8} wrap={false} style={{ width: '100%' }}>
      <Col flex="1">
        <DatePicker
          inputReadOnly
          showTime={false}
          allowClear={false}
          placeholder="Select date"
          disabledDate={(current) => current < dayjs().startOf('day')}
          format="DD/MM/YYYY"
          style={{ width: '100%' }}
          value={dateTime?.startAt ? dayjs(dateTime?.startAt) : undefined}
          onChange={handleDateChange}
        />
      </Col>
      <Col flex="1">
        <Select
          defaultValue="8:00"
          placeholder="Start time"
          style={{ width: '100%', height: 32 }}
          options={timeSelectOptions}
          value={
            timeSelectOptions.some(
              (time) => time.value === dayjs(dateTime?.startAt).format('HH:mm')
            )
              ? dayjs(dateTime?.startAt).format('HH:mm')
              : '08:00'
          }
          onChange={(e) => handleTimeChange(e)}
        />
      </Col>
    </Row>
  );
};

interface IOption {
  value: string;
  label: string;
}

const timeSelectOptions: IOption[] = Array.from({ length: 13 }, (_, hour) =>
  Array.from({ length: 4 }, (_, index) => {
    const hourValue = (hour + 8) % 24;
    const minuteValue = index * 15;
    const formattedHour = hourValue.toString().padStart(2, '0');
    const formattedMinute = minuteValue.toString().padStart(2, '0');
    const time = `${formattedHour}:${formattedMinute}`;
    return { value: time, label: time };
  })
).flat();
